import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

const { takeEvery } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    try {
        yield firestore.unsetListener({
            collection: `imports/${meta.importId}/logs`,
            storeAs: 'logs',
            orderBy: ['timestamp', 'desc'],
        });
    } catch (e) {
        loglevel.error(e);
    }
}

export default function* () {
    yield takeEvery(types.UNLISTEN_LOGS, handler);
}
